
import Vue, { PropType } from 'vue';

// Types
import { CandidateJobBuilder, JobMembership } from '~/utils/candidate';
import { jobMembershipValidator } from '~/utils/validators';

// Components
import Input from '~/components/builders/Base/Input.vue';
import YearMonthPicker from '~/components/builders/YearMonthPicker.vue';
import Checkbox from '~/components/builders/Base/Checkbox.vue';
import RichTextEditor from '~/components/builders/RichTextEditor.vue';

export default Vue.extend({
    name: 'MembershipListItemForm',
    components: { Input, YearMonthPicker, Checkbox, RichTextEditor },
    props: {
        value: {
            type: Object as PropType<JobMembership>,
            required: true,
        },
    },
    data() {
        return {
            membership: { ...this.value } as JobMembership,
        };
    },
    computed: {
        isValid(): boolean {
            return jobMembershipValidator(this.membership);
        },
        isTempItem(): boolean {
            return CandidateJobBuilder.isTempItem(this.membership);
        },
    },
    methods: {
        updateIsMembershipActive(isMembershipActive: boolean) {
            this.membership.isActive = isMembershipActive;
            if (isMembershipActive) {
                this.membership.end = null;
            }
        },
    },
});
